<template>
  <PageShell :background="background" wide>
    <PageHeader size="page" align="start" :title="t('gallery.title')" :lead="t('gallery.lead')" />
    <PhotoGallery />
    <ClosingCta />
  </PageShell>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import PageShell from '@/components/public/PageShell.vue';
import PageHeader from '@/components/public/PageHeader.vue';
import PhotoGallery from '@/components/PhotoGallery.vue';
import ClosingCta from '@/components/public/ClosingCta.vue';
import background from '@/assets/images/backgrounds/common/gallery-hero.webp';

const { t } = useI18n();
</script>
